/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Button, Modal, Nav, NavDropdown } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import _ from 'underscore';
import cn from 'classnames';
import * as Fa from 'react-icons/fa';
import { Manifest } from 'services/action';

import MenuRoute from './menu.route';
import Form from '../form';

const MenuConsended = ({ fluid }) => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const session = useSelector((state) => state?.Auth?.session);
  const location = useLocation();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Get'],
  );
  const [showScan, setShowScan] = React.useState(false);
  const [manifestID, setManifestID] = React.useState('');
  const [isError, setIsError] = React.useState(false);
  const [showTransit, setShowTransit] = React.useState(false);

  const { pathname } = location;
  const splitLocation = pathname.split('/');

  const $onScan = async (e) => {
    const getId = (url) => url?.substring(url?.lastIndexOf('/') + 1);

    setManifestID(getId(e?.target?.value));
    setIsError(false);
  };

  const $onTransit = async (e) => {
    setIsError(false);
    let res = await Dispatch(
      Manifest.$get({
        search: manifestID,
        destination_id: session?.hub?.id,
        exclude_hub: true,
        exclude: 'new',
        limit: 1,
      }),
    );

    if (res?.message !== 'success' || res?.total !== 1) {
      setIsError(true);
    } else {
      $onClose();
      const manifest = res?.data[0];
      History.push(`/manifest/${manifest?.id}`);
    }
  };

  const $onClose = async () => {
    setShowScan(false);
    setIsError(false);
    setManifestID('');
  };

  React.useEffect(() => {
    if (session?.privileges) {
      let y = _.findWhere(session?.privileges, { service: 'nvo.tms.manifest' });

      if (y?.action === 'manage') {
        setShowTransit(true);
      }
    } else {
      setShowTransit(true);
    }
  }, []);

  return (
    <div className="navbar-collapse collapse" id="navbar-menu">
      <div className="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center">
        <div className={fluid ? 'container-fluid' : 'container-xl'}>
          <ul className="navbar-nav">
            {MenuRoute.map((menu, index) => {
              let link = null;

              // ini report hanya untuk envio sendiri, karena report ini untuk internal envio saja, jadi tidak semua client bisa akses report ini, jadi di hidden untuk client lain selain envio
              if (
                session?.client?.id !== '16a5d350-12a1-407b-b55f-0252b7df8d0a'
              ) {
                if (menu?.title === 'Report') {
                  return null;
                }
              }

              if (!menu?.isMaster) {
                if (session?.privileges) {
                  let child = [];

                  let privileges = session?.privileges?.map((h) => h?.service);

                  menu?.service?.forEach((g) => {
                    if (privileges?.includes(g)) {
                      child?.push(g);
                    }
                  });

                  if (child?.length > 0) {
                    link = !menu?.isDropdown ? (
                      <li key={index} className="nav-item">
                        <NavLink
                          to={menu.path}
                          className="nav-link"
                          activeClassName="active"
                          isActive={(match, location) => {
                            const splitLocation = location.pathname.split('/');

                            if (splitLocation[1] === menu.isActive) {
                              return true;
                            }
                          }}
                        >
                          <div className="d-flex justify-content-center">
                            <span className="nav-link-icon d-md-none d-lg-inline-block">
                              {menu.icon}
                            </span>
                            <span className="nav-link-title">
                              {menu?.title}
                            </span>
                          </div>
                        </NavLink>
                      </li>
                    ) : (
                      <li key={index} className="nav-item">
                        <Nav>
                          <NavDropdown
                            active={splitLocation[1] === menu?.isActive}
                            menuVariant="dark"
                            // className="no-carret"
                            title={
                              <div className="d-flex justify-content-center align-items-center m-0">
                                <span
                                  className="nav-link-icon d-inline-block m-0 pe-2"
                                  style={{
                                    width: 'auto',
                                    height: 'auto',
                                  }}
                                >
                                  {menu.icon}
                                </span>
                                {menu?.title}
                              </div>
                            }
                          >
                            {menu?.child.map((c, index) => {
                              let menu = null;

                              if (session?.privileges) {
                                let x = _.findWhere(session?.privileges, {
                                  service: c?.service,
                                });

                                if (x) {
                                  menu = (
                                    <NavDropdown.Item
                                      key={index}
                                      onClick={() => History.push(c?.path)}
                                      active={
                                        splitLocation[2] === c?.isActive ||
                                        (splitLocation?.length === 2 &&
                                          splitLocation[1] === c?.isActive)
                                      }
                                    >
                                      <div className="d-flex justify-content-center">
                                        <span className="nav-link-icon d-md-none d-lg-inline-block">
                                          {c?.icon}
                                        </span>
                                        <span className="nav-link-title">
                                          {c?.title}
                                        </span>
                                      </div>
                                    </NavDropdown.Item>
                                  );
                                }
                              }
                              return menu;
                            })}
                          </NavDropdown>
                        </Nav>
                      </li>
                    );
                  }
                } else {
                  link = !menu.isDropdown ? (
                    <li key={index} className="nav-item">
                      <NavLink
                        to={menu.path}
                        className="nav-link"
                        activeClassName="active"
                        isActive={(match, location) => {
                          const splitLocation = location.pathname.split('/');

                          if (splitLocation[1] === menu.isActive) {
                            return true;
                          }
                        }}
                      >
                        <div className="d-flex justify-content-center">
                          <span className="nav-link-icon d-md-none d-lg-inline-block">
                            {menu.icon}
                          </span>
                          <span className="nav-link-title">{menu?.title}</span>
                        </div>
                      </NavLink>
                    </li>
                  ) : (
                    <li key={index} className="nav-item">
                      <Nav>
                        <NavDropdown
                          active={splitLocation[1] === menu?.isActive}
                          menuVariant="dark"
                          // className="no-carret"
                          title={
                            <div className="d-flex justify-content-center align-items-center m-0">
                              <span
                                className="nav-link-icon d-inline-block m-0 pe-2"
                                style={{
                                  width: 'auto',
                                  height: 'auto',
                                }}
                              >
                                {menu.icon}
                              </span>
                              {menu?.title}
                            </div>
                          }
                        >
                          {menu?.child.map((c, index) => {
                            let menu = (
                              <NavDropdown.Item
                                key={index}
                                onClick={() => History.push(c?.path)}
                                active={
                                  splitLocation[2] === c?.isActive ||
                                  (splitLocation?.length === 2 &&
                                    splitLocation[1] === c?.isActive)
                                }
                              >
                                <div className="d-flex justify-content-center">
                                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                                    {c?.icon}
                                  </span>
                                  <span className="nav-link-title">
                                    {c?.title}
                                  </span>
                                </div>
                              </NavDropdown.Item>
                            );

                            return menu;
                          })}
                        </NavDropdown>
                      </Nav>
                    </li>
                  );
                }
              }

              return link;
            })}

            {showTransit && (
              <li className="nav-item">
                <div className="nav-link" onClick={() => setShowScan(true)}>
                  <div className="d-flex justify-content-center">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <Fa.FaBarcode size={18} style={{ marginTop: 2 }} />
                    </span>
                    <span className="nav-link-title">Transit</span>
                  </div>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>

      <Modal
        show={showScan}
        onHide={$onClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$onClose} />
          <div className="modal-status bg-primary" />
          <h3>Scan Manifest</h3>
          <Form.Input
            mb0
            value={manifestID}
            onChange={$onScan}
            type="text"
            placeholder="Masukkan kode manifest"
            error={isError ? 'Kode manifest tidak valid' : false}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$onClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={cn(StateLoading ? 'btn-loading' : '', 'w-100')}
                onClick={$onTransit}
              >
                Konfirmasi
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MenuConsended;
